module.exports = __webpack_public_path__ + "cloud-idea.1NQkQ0TG.svg";